module.exports = __webpack_public_path__ + "static/customer-headshot-2@2x-794c514ca20e46bdf7cf6622cb6fe73d.jpg";